import { useCallback, useEffect, useState } from 'react';
import { fetchParkingQueueRules, saveParkingQueueRules } from '../../api/parkingQueueRulesApi';
import { ParkingQueueRules } from '../../types/parkingQueueRules';

export interface UseParkingQueueRulesReturn {
    rules: ParkingQueueRules | null;
    loading: boolean;
    saving: boolean;
    error: string | null;
    save: (text: string) => Promise<void>;
}

/** The "Regler för kön" text, read on mount, and its admin save. */
export const useParkingQueueRules = (): UseParkingQueueRulesReturn => {
    const [rules, setRules] = useState<ParkingQueueRules | null>(null);
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        let cancelled = false;
        fetchParkingQueueRules()
            .then(r => { if (!cancelled) setRules(r); })
            .catch(e => { console.error(e); if (!cancelled) setError('Kunde inte läsa reglerna för kön'); })
            .finally(() => { if (!cancelled) setLoading(false); });
        return () => { cancelled = true; };
    }, []);

    const save = useCallback(async (text: string) => {
        setSaving(true);
        setError(null);
        try {
            setRules(await saveParkingQueueRules(text));
        } catch (e) {
            setError(e instanceof Error ? e.message : 'Kunde inte spara reglerna');
            throw e;
        } finally {
            setSaving(false);
        }
    }, []);

    return { rules, loading, saving, error, save };
};
